<template>
  <div class="AppDetailedForcast">
    <!-- <el-button
      type="text"
      @click="dialogVisible = true"
    >
      PopUp screen on click of store
    </el-button> -->
    <!-- <el-dialog
      title=""
      :visible.sync="dialogVisible"
    > -->
    <div class="dialog-title">
      Forecast for {{ queryDetailResponse.buttonClickedObject.storeName }} :
      {{ forecastDate }}
    </div>

    <div class="main-section">
      <div class="section">
        <div class="dateTemp">
          <div class="dateDiv">
            <p class="text-sm uppercase font-bold">Last Year</p>
            <p class="text-xs uppercase font-semibold">{{ lastYearDate }}</p>
          </div>
          <div class="temperature">
            <p class="text-lg font-bold">
              {{
                `${
                  queryDetailResponse.date_offset_year.temp_max
                    ? queryDetailResponse.date_offset_year.temp_max
                    : "-"
                } / ${
                  queryDetailResponse.date_offset_year.temp_min
                    ? queryDetailResponse.date_offset_year.temp_min
                    : "-"
                }`
              }}
              <span>&#176;c</span>
            </p>
          </div>
          <img width="40" height="40" :src="offSetYearWeather" alt="" />
          <p class="text-xs capitalize font-semibold">
            {{ queryDetailResponse.date_offset_year.weather }}
          </p>
        </div>
        <div class="events">
          <simplebar class="simplebar">
            <div class="events-heading-bar">
              <!-- <p class="font-semibold text-sm">EVENTS</p> -->
              <!-- <BaseButton
								type="submit"
								class="w-16 mr-3 hidden"
								buttonclass="btn py-1 text-xs "
							>ADD
							</BaseButton> -->
            </div>
            <div class="EIevents-parent">
              <div class="EIevents">
                <div>
                  <p class="text-sm font-semibold">External -</p>
                </div>
                <div class="EIeventsContainer">
                  <div
                    v-for="item in queryDetailResponse.date_offset_year
                      .external_events"
                    :key="item"
                    class="showEvents"
                  >
                    <span>{{ item }} </span>
                  </div>
                </div>
              </div>
              <div class="EIevents">
                <div>
                  <p class="text-sm font-semibold">Internal &nbsp;-</p>
                </div>
                <div class="EIeventsContainer">
                  <div
                    v-for="item in queryDetailResponse.date_offset_year
                      .internal_events"
                    :key="item"
                    class="showEvents"
                  >
                    <span> {{ item }} </span>
                  </div>
                </div>
              </div>
            </div>
          </simplebar>
        </div>

        <div style="padding: 10px;">
          <div class="text-left inline-block" style="width: 50%;">
            <div class="text-xs font-semibold text-black">Transactions:</div>
          </div>
          <div class="text-left inline-block" style="width: 50%;">
            {{ queryDetailResponse.date_offset_year.sales }}
          </div>
        </div>

        <div class="flex justify-between text-black" style="padding: 10px;">
          &nbsp;
        </div>

        <div style="padding: 10px;">
          <div class="text-left inline-block" style="width: 50%;">
            <div class="text-xs font-semibold text-black">Sales:</div>
          </div>
          <div class="text-left inline-block" style="width: 50%;">
            INR {{ queryDetailResponse.date_offset_year.amount }}
          </div>
        </div>
      </div>

      <div class="section">
        <div class="dateTemp">
          <div class="dateDiv">
            <p class="text-sm uppercase font-bold">Last {{ lastWeekDay }}</p>
            <p class="text-xs uppercase font-semibold">{{ lastWeekDate }}</p>
          </div>
          <div class="temperature">
            <p class="text-lg font-bold">
              {{
                `${
                  queryDetailResponse.date_offset_week.temp_max
                    ? queryDetailResponse.date_offset_week.temp_max
                    : "-"
                } / ${
                  queryDetailResponse.date_offset_week.temp_min
                    ? queryDetailResponse.date_offset_week.temp_min
                    : "-"
                }`
              }}
              <span>&#176;c</span>
            </p>
          </div>
          <img width="40" height="40" :src="offsetWeekWeather" />
          <p class="text-xs capitalize font-semibold">
            {{ queryDetailResponse.date_offset_week.weather }}
          </p>
        </div>
        <div class="events">
          <simplebar class="simplebar">
            <div class="events-heading-bar">
              <!-- <p class="font-semibold text-sm">EVENTS</p> -->
              <!-- <BaseButton
								type="submit"
								class="w-16 mr-3"
								buttonclass="btn py-1 text-xs "
							>ADD
							</BaseButton> -->
            </div>
            <div class="EIevents-parent">
              <div class="EIevents">
                <div>
                  <p class="text-sm font-semibold">External -</p>
                </div>
                <div class="EIeventsContainer">
                  <div
                    v-for="item in queryDetailResponse.date_offset_week
                      .external_events"
                    :key="item"
                    class="showEvents"
                  >
                    <span>{{ item }} </span>
                  </div>
                </div>
              </div>
              <div class="EIevents">
                <div>
                  <p class="text-sm font-semibold">Internal &nbsp;-</p>
                </div>
                <div class="EIeventsContainer">
                  <div
                    v-for="item in queryDetailResponse.date_offset_week
                      .internal_events"
                    :key="item"
                    class="showEvents"
                  >
                    <span>{{ item }} </span>
                  </div>
                </div>
              </div>
            </div>
          </simplebar>
        </div>

        <div style="padding: 10px;">
          <div class="text-left inline-block" style="width: 50%;">
            <div class="text-xs font-semibold text-black">Transactions:</div>
          </div>
          <div class="text-left inline-block" style="width: 50%;">
            {{ queryDetailResponse.date_offset_week.sales }}
          </div>
        </div>

        <div class="flex justify-between text-black" style="padding: 10px;">
          &nbsp;
        </div>

        <div style="padding: 10px;">
          <div class="text-left inline-block" style="width: 50%;">
            <div class="text-xs font-semibold text-black">Sales:</div>
          </div>
          <div class="text-left inline-block" style="width: 50%;">
            INR {{ queryDetailResponse.date_offset_week.amount }}
          </div>
        </div>
      </div>

      <div class="section">
        <div class="dateTemp">
          <div class="dateDiv">
            <p
              class="text-sm uppercase font-bold flex items-center justify-center"
            >
              <span class="mr-1"> Forecast </span>
              <span
                v-if="queryDetailResponse.buttonClickedObject.isApproved"
                class="flex items-center justify-center"
              >
                <i class="el-icon-success text-green text-base" />
                <span class="text-xs"> Approved </span>
              </span>
            </p>
            <p class="text-xs uppercase font-semibold">{{ forecastDate }}</p>
          </div>
          <!-- <p>
            <input
              type="radio"
              name="Approve"
              value="Approve"
            > Approve<br>
          </p> -->
          <div class="temperature">
            <p class="text-lg font-bold">
              {{
                `${
                  queryDetailResponse.date_offset_null.temp_max
                    ? queryDetailResponse.date_offset_null.temp_max
                    : "-"
                } / ${
                  queryDetailResponse.date_offset_null.temp_min
                    ? queryDetailResponse.date_offset_null.temp_min
                    : "-"
                }`
              }}
              <span>&#176;c</span>
            </p>
          </div>
          <img width="40" height="40" :src="offsetNullWeather" />
          <p class="text-xs capitalize font-semibold">
            {{ queryDetailResponse.date_offset_null.weather }}
          </p>
        </div>

        <div class="events">
          <simplebar class="simplebar">
            <div class="events-heading-bar">
              <!-- <p class="font-semibold text-sm">EVENTS</p> -->
              <!-- <BaseButton
								type="submit"
								class="w-16 mr-3"
								buttonclass="btn py-1 text-xs "
							>ADD
							</BaseButton> -->
            </div>
            <div class="EIevents-parent">
              <div class="EIevents">
                <div>
                  <p class="text-sm font-semibold" style="width: 100px">
                    External -
                  </p>
                </div>
                <div class="EIeventsContainer">
                  <div
                    v-for="item in queryDetailResponse.date_offset_null
                      .external_events"
                    :key="item"
                    class="showEvents"
                  >
                    <span>{{ item }} </span>
                  </div>
                </div>
              </div>
              <div class="EIevents">
                <div>
                  <p class="text-sm font-semibold" style="width: 100px">
                    Internal &nbsp;-
                  </p>
                </div>
                <div class="EIeventsContainer">
                  <div
                    v-for="item in queryDetailResponse.date_offset_null
                      .internal_events"
                    :key="item"
                    class="showEvents"
                  >
                    <span style="word-break: break-word">{{ item }} </span>
                  </div>
                </div>
              </div>
              <div class="EIevents">
                <div>
                  <p class="text-sm font-semibold" style="width: 100px">
                    Event History-
                  </p>
                </div>

                <div
                  v-if="
                    Object.keys(queryDetailResponse.date_offset_null).length &&
                    queryDetailResponse.date_offset_null.events_history.length
                  "
                  class="EIeventsContainer"
                  style="max-height: 50px; overflow-y: auto"
                >
                  <div
                    v-for="(history, history_index) in queryDetailResponse
                      .date_offset_null.events_history"
                    :key="history_index"
                    class="showEvents"
                    style="
                      border-bottom: 1px solid #ddd;
                      margin-bottom: 5px;
                      padding-bottom: 5px;
                    "
                  >
                    <span>{{ history.event }}</span>

                    <p class="my-1 ml-1 text-xxs text-grey">
                      {{ moment(history.date).format("ddd, MMM DD YYYY") }}
                    </p>

                    <span class="my-1 font-semibold"
                      >{{ history.txns }} Txns.</span
                    >
                    &nbsp;
                    <span v-if="history.pid_txns > 0" class="text-green text-xs"
                      >{{ history.pid_txns }}%
                      <i class="el-icon-top"></i>
                    </span>
                    <span v-if="history.pid_txns < 0" class="text-red text-xs"
                      >{{ history.pid_txns }}%
                      <i class="el-icon-bottom"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div class="text-center">
                <el-button
                  size="mini"
                  class="action-btn"
                  @click="openAddEventDailog()"
                  >ADD EVENTS</el-button
                >
              </div>
            </div>
          </simplebar>
        </div>

        <div class="approveForecast">
          <!-- <img
            width="35"

            src="../../../assets/images/appForecastDetails/plus.png"
            alt=""
          > -->
          <!-- <label class="text-black text-base" for="">
						Sales
					</label> -->

          <div style="padding: 10px;">
            <div class="text-left inline-block" style="width: 50%;">
              <div class="text-xs font-semibold text-black">Transactions Forecast:</div>
            </div>
            <div class="text-left inline-block" style="width: 50%;">
              {{ modifiedSales }}
            </div>
          </div>

          <div style="padding: 10px;">
            <div class="text-left inline-block" style="width: 50%;">
              <div class="text-xs font-semibold text-black">Adjusted Transactions:</div>
            </div>

            <div class="text-left inline-block" style="width: 50%;">
              <el-input
                v-model="adjusted_transactions"
                type="number"
                size="mini"
                style="width: 75px;"
              />

              <span class="ml-2" style="font-size: 0.7rem;" :class="[adjusted_transactions > modifiedSales ? 'text-green' : adjusted_transactions < modifiedSales ? 'text-red' : '']">
              {{ percentageDiff(adjusted_transactions, modifiedSales) }}%

                <i v-if="adjusted_transactions > modifiedSales" class="el-icon-top"></i>
                <i v-if="adjusted_transactions < modifiedSales" class="el-icon-bottom"></i>
              </span>
            </div>
          </div>

          <div style="padding: 10px;">
            <div class="text-left inline-block" style="width: 50%;">
              <div class="text-xs font-semibold text-black">Sales:</div>
            </div>
            <div class="text-left inline-block" style="width: 50%;">
              INR {{ queryDetailResponse.date_offset_null.amount }}
            </div>
          </div>

          <!-- <img
            width="35"
            src="../../../assets/images/appForecastDetails/minus.png"
            alt=""
          > -->
        </div>
      </div>
    </div>

    <div class="approveForecastBtn">
      <BaseButton
        class="btn text-xs"
        :buttonclass="buttonclass.class"
        :class="{
          'forecast-approved':
            queryDetailResponse.buttonClickedObject.isApproved,
        }"
        :disabled="disabledAllow"
        @click="approveForecast"
      >
        {{
          queryDetailResponse.buttonClickedObject.isApproved
            ? "Update"
            : queryDetailResponse.buttonClickedObject.value
        }}
      </BaseButton>
    </div>

    <span slot="footer" class="dialog-footer" />

    <!-- add Event section -->
    <div class="add-event-dialog">
      <el-dialog
        title="Add Event"
        :visible.sync="add_event_dialog_visible"
        width="50%"
        :before-close="handleClose"
      >
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <p class="py-2">Event Name <span style="color: red">*</span></p>
            <BaseInput
              v-model="event_name"
              v-validate="'required'"
              class="baseInput"
              style="width: 100%"
              custom-class="text-sm  text-amp-input-boxes"
              type="text"
              name="eventName"
            />
            <p>
              <span
                :v-show="errors.has(`eventName`)"
                class="text-red-dark text-xs"
              >
                {{ errors.first(`eventName`) }}
              </span>
            </p>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <p class="py-2">Event Type <span style="color: red">*</span></p>
            <el-select
              v-model="event_type"
              v-validate="'required'"
              name="eventType"
              style="width: 100%"
              placeholder="Event Type"
              @change="eventType(event_type)"
            >
              <el-option
                v-for="(item, index) in event_type_list"
                :key="index"
                :value="item.value"
                :label="item.name"
              >
                {{ item.name }}
              </el-option>
            </el-select>
            <p>
              <span
                :v-show="errors.has(`eventType`)"
                class="text-red-dark text-xs"
              >
                {{ errors.first(`eventType`) }}
              </span>
            </p>
          </el-col>

          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <p class="py-2">Event Category <span style="color: red">*</span></p>
            <el-select
              v-model="event_category"
              v-validate="'required'"
              name="event Category"
              style="width: 100%"
              placeholder="Event Category"
            >
              <el-option
                v-for="(item, index) in event_categoty"
                :key="index"
                :value="item.id"
                :label="item.name"
              >
                {{ item.name }}
              </el-option>
            </el-select>
            <p>
              <span
                :v-show="errors.has(`event Category`)"
                class="text-red-dark text-xs"
              >
                {{ errors.first(`event Category`) }}
              </span>
            </p>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <p class="py-2">From <span style="color: red">*</span></p>
            <el-date-picker
              v-model="event_start_date"
              v-validate="'required'"
              style="width: 100%"
              type="date"
              placeholder="From Date"
              name="from date"
              :picker-options="date_range_options"
              @change="event_start_date ? '' : (event_end_date = '')"
            ></el-date-picker>
            <p>
              <span
                :v-show="errors.has(`from date`)"
                class="text-red-dark text-xs"
              >
                {{ errors.first(`from date`) }}
              </span>
            </p>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <p class="py-2">To <span style="color: red">*</span></p>
            <el-date-picker
              v-model="event_end_date"
              v-validate="add_event_dialog_visible ? 'required' : ''"
              style="width: 100%"
              type="date"
              placeholder="To Date"
              :picker-options="{
                disabledDate: (date) => {
                  return date < event_start_date;
                },
                firstDayOfWeek: 1,
              }"
              :disabled="!event_start_date"
              name="to date"
            ></el-date-picker>
            <p>
              <span
                :v-show="errors.has(`to date`)"
                class="text-red-dark text-xs"
              >
                {{ errors.first(`to date`) }}
              </span>
            </p>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <p class="py-2">Start Time</p>
            <el-time-select
              v-model="evnet_start_time"
              style="width: 100%"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:59',
              }"
              placeholder="Start Time"
              :disabled="event_type == 'store_closed'"
            >
            </el-time-select>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <p class="py-2">End Time</p>
            <el-time-select
              v-model="event_end_time"
              style="width: 100%"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:59',
              }"
              placeholder="Start Time"
              :disabled="event_type == 'store_closed'"
            >
            </el-time-select>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <p class="py-2">Sales Impact</p>
            <div class="flex items-center">
              <el-select
                :value="sales_impact"
                style="width: 100%"
                name="Sales Impact"
                placeholder="Sales Impact"
                :filterabe="true"
                @change="changeSalesImpact(sales_impact, $event)"
              >
                <el-option
                  v-for="(item, itemIndex) in sales_impact_list"
                  :key="itemIndex"
                  :label="item.title"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <span class="ml-2 cursor-pointer"
                ><img src="../../../assets/images/info.png" width="18"
              /></span>
            </div>
          </el-col>
        </el-row>

        <p class="py-2">Description</p>
        <textarea
          v-model="description"
          class="description-textarea p-2"
          name=""
        ></textarea>

        <div class="text-right pt-2">
          <div class="flex justify-end">
            <BaseButton
              type="submit"
              class="w-24 mr-4"
              buttonclass="btn p-2 text-xs "
              @click="add_event_dialog_visible = false"
            >
              Cancel
            </BaseButton>
            <BaseButton
              type="submit"
              class="w-24"
              buttonclass="btn p-2 text-xs "
              @click="saveNewEvent()"
            >
              Add
            </BaseButton>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- </el-dialog> -->
    <!-- {{ queryDetailResponse }} -->
  </div>
</template>

<script>
import moment from "moment";
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
import ForecastService from "../../../services/forecastService";
import LabourPalnningService from "../../../services/labourPalnningService";

import { EventBus } from "../../../eventBus";
import { mapState } from "vuex";
const weatherIconMap = {
  thunderstorm: require("../../../assets/images/appForecastDetails/thunderstorm.png"),
  drizzle: require("../../../assets/images/appForecastDetails/drizzle.png"),
  rain: require("../../../assets/images/appForecastDetails/rain.png"),
  snow: require("../../../assets/images/appForecastDetails/snow.png"),
  mist: require("../../../assets/images/appForecastDetails/mist.png"),
  smoke: require("../../../assets/images/appForecastDetails/mist.png"),
  haze: require("../../../assets/images/appForecastDetails/mist.png"),
  dust: require("../../../assets/images/appForecastDetails/sand-storm.png"),
  fog: require("../../../assets/images/appForecastDetails/mist.png"),
  sand: require("../../../assets/images/appForecastDetails/sand-storm.png"),
  ash: require("../../../assets/images/appForecastDetails/mist.png"),
  squall: require("../../../assets/images/appForecastDetails/mist.png"),
  tornado: require("../../../assets/images/appForecastDetails/tornado.png"),
  clear: require("../../../assets/images/appForecastDetails/clear.png"),
  clouds: require("../../../assets/images/appForecastDetails/cloudy.png"),
  "01d": require("../../../assets/images/AppDetailedDForecastV2/01d.png"),
  "02d": require("../../../assets/images/AppDetailedDForecastV2/02d.png"),
  "03d": require("../../../assets/images/AppDetailedDForecastV2/03d.png"),
  "04d": require("../../../assets/images/AppDetailedDForecastV2/04d.png"),
  "09d": require("../../../assets/images/AppDetailedDForecastV2/09d.png"),
  "10d": require("../../../assets/images/AppDetailedDForecastV2/10d.png"),
  "11d": require("../../../assets/images/AppDetailedDForecastV2/11d.png"),
  "13d": require("../../../assets/images/AppDetailedDForecastV2/13d.png"),
  "50d": require("../../../assets/images/AppDetailedDForecastV2/50d.png"),
};
export default {
  name: "AppDetailedForcast",
  components: {
    simplebar,
  },
  props: {
    queryDetailResponse: {
      type: Object,
      required: true,
    },
    disabledAllow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modifiedSales: this.queryDetailResponse.date_offset_null.sales,
      adjusted_transactions: this.queryDetailResponse.date_offset_null.adjusted_quantity,
      add_event_dialog_visible: false,
      event_type_list: [
        {
          name: "Internal",
          value: "internal",
        },
        {
          name: "External",
          value: "external",
        },
      ],
      event_name: "",
      event_type: "",
      event_start_date: "",
      event_end_date: "",
      event_category: "",
      evnet_start_time: "",
      event_end_time: "",
      sales_impact: "0",
      sales_impact_list: [],
      description: "",
      event_categoty: [],
      all_event_categoty_list: [],
      date_range_options: {
        firstDayOfWeek: 1,
      },
      moment: moment,
    };
  },
  computed: {
    ...mapState("AppForecastStore", ["forecastAnalytics"]),
    buttonclass() {
      return {
        class: this.queryDetailResponse.buttonClickedObject.isApproved
          ? "py-2 px-4 text-xs text-white hover:text-green-light"
          : "py-2 px-4 text-xs text-white hover:text-amp-light",
      };
    },
    offsetWeekWeather() {
      return weatherIconMap[
        this.queryDetailResponse.date_offset_week.weather_icon
      ];
    },
    offSetYearWeather() {
      return weatherIconMap[
        this.queryDetailResponse.date_offset_year.weather_icon
      ];
    },
    offsetNullWeather() {
      return weatherIconMap[
        this.queryDetailResponse.date_offset_null.weather_icon
      ];
    },
    lastYearDate() {
      return moment(this.queryDetailResponse.buttonClickedObject.date)
        .subtract(1, "years")
        .format("ddd, MMM Do YYYY");
    },
    lastWeekDate() {
      return moment(this.queryDetailResponse.buttonClickedObject.date)
        .subtract(7, "days")
        .format("ddd, MMM Do YYYY");
    },
    forecastDate() {
      return moment(this.queryDetailResponse.buttonClickedObject.date).format(
        "ddd, MMM Do YYYY"
      );
    },
    lastWeekDay() {
      return moment(this.queryDetailResponse.buttonClickedObject.date).format(
        "dddd"
      );
    },
  },

  created() {
    this.getEventCategory();

    for (var x = -100; x <= 101; x++) {
      if (x % 5 == 0) {
        let obj = {};
        obj.title = x + "%";
        obj.value = x;
        this.sales_impact_list.push(obj);
      }
    }
  },

  methods: {
    percentageDiff(adjusted_transactions, forecast_transactions){
      return (((adjusted_transactions - forecast_transactions)/forecast_transactions)*100).toFixed(1);
    },

    // displayed confirmation box and if confirmed then assigned new value to sales impact otherwise assigned old value
    changeSalesImpact(old_sales_impact, new_sales_impact) {
      this.$confirm(
        `Sales Impact % will adjust your transactions forecast by ${new_sales_impact}% for selected dates`,
        "Alert",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          this.sales_impact = new_sales_impact;
        })
        .catch(() => {
          this.sales_impact = old_sales_impact;
        });
    },

    openAddEventDailog() {
      this.clearEventFormInput();
      console.log(
        "this.queryDetailResponse.buttonClickedObject.id",
        this.queryDetailResponse.buttonClickedObject.id
      );
      this.add_event_dialog_visible = true;
    },

    handleClose() {
      this.add_event_dialog_visible = false;
    },

    getEventCategory() {
      LabourPalnningService.getEventyCategory()
        .then((response) => {
          this.all_event_categoty_list = JSON.parse(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    eventType(type) {
      this.event_category = "";
      if (type == "internal") {
        this.event_categoty = this.all_event_categoty_list.filter((e) => {
          if (e.type == "Internal") {
            return e;
          }
        });
      } else {
        this.event_categoty = this.all_event_categoty_list.filter((e) => {
          if (e.type == "External") {
            return e;
          }
        });
      }
    },

    saveNewEvent() {
      let params = {
        name: this.event_name,
        start_date: moment(this.event_start_date).format("YYYY-MM-DD"),
        end_date: moment(this.event_end_date).format("YYYY-MM-DD"),
        start_time: this.evnet_start_time
          ? this.evnet_start_time + ":00"
          : "00:00:00",
        end_time: this.event_end_time
          ? this.event_end_time + ":00"
          : "00:00:00",
        countries: [],
        regions: [],
        subregions: [],
        stores: [{ id: this.queryDetailResponse.buttonClickedObject.id }],
        category: this.event_category,
        description: this.description,
        impact_sales: this.sales_impact,
      };

      console.log("params", params);

      this.$validator.validateAll().then((result) => {
        if (result) {
          LabourPalnningService.createNewEvent(params)
            .then((response) => {
              if (response.status === 201) {
                this.add_event_dialog_visible = false;

                EventBus.$emit("closeDialogBoxEvent");

                this.$notify.success({
                  title: "Success",
                  message: "Event Created Successfully",
                });

                this.clearEventFormInput();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    clearEventFormInput() {
      this.event_name = "";
      this.event_type = "";
      this.event_start_date = "";
      this.event_end_date = "";
      this.event_category = "";
      this.evnet_start_time = "";
      this.event_end_time = "";
      this.description = "";
      this.sales_impact = "0";
    },

    approveForecast() {
      const queryObject = {
        date: this.queryDetailResponse.buttonClickedObject.date,
        old_forecast: this.queryDetailResponse.date_offset_null.sales,
        new_forecast: this.adjusted_transactions,
        approve: true,
        outlet: this.queryDetailResponse.buttonClickedObject.id,
      };
      ForecastService.approveForecast(queryObject)
        .then((response) => {
          if (response.status == 200) {
            this.forecastApproved(JSON.parse(response.data).data);
            EventBus.$emit("closeDialogBoxEvent");
            this.$notify.success({
              title: "Success",
              message: "Approved",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify.error({
            title: "Fail",
            message: "Error",
          });
        });
    },

    forecastApproved(approvedForecast) {
      this.forecastAnalytics.data.rows.forEach((arr, arrIndex, row) => {
        arr.forEach((obj, objIndex) => {
          if (
            obj.hasOwnProperty("date") &&
            obj.date == this.queryDetailResponse.buttonClickedObject.date
          ) {
            obj.isApproved = true;
            obj.value = "Approved";
            row[arrIndex][7].value = approvedForecast; // update forecast value in table.
          }
        });
      });
    },
    modifiedSalesValue(event) {
      this.modifiedSales = Number(event.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./AppDetailedForcast.scss";
@import "../../../assets/css/variable.scss";
.AppDetailedForcast {
  .action-btn {
    background-color: #e29d5a;
    border-color: #e29d5a;
    color: #fff;
  }
}
</style>
<style lang="scss">
.AppDetailedForcast {
  .add-event-dialog .el-dialog {
    width: 50%!important;
  }
  .add-event-dialog .el-dialog__title {
    text-transform: capitalize;
    color: #ffffff;
  }
  .el-dialog__body {
    padding: 30px 20px !important;
  }
  .description-textarea {
    width: 100%;
    height: 75px;
    border: 1px solid #dcdfe6;
    resize: none;
    border-radius: 4px;
    outline: none;
  }
  .add-event-dialog .el-dialog__header {
    background: #2e323a;
    color: #ffffff;
    padding: 15px;
  }
  .add-event-dialog .el-dialog__headerbtn .el-dialog__close:hover {
    color: #ffffff;
  }
  .add-event-dialog .el-dialog__headerbtn:focus .el-dialog__close,
  .el-dialog__headerbtn:hover .el-dialog__close:hover {
    color: #ffffff;
  }
}

/* .AppDetailedForcast .el-dialog__body {
	padding: 0;
}
.AppDetailedForcast .el-dialog__header {
	padding: 0;
}
.AppDetailedForcast .el-icon-close:before {
	color: #fff;
}
.AppDetailedForcast .el-dialog {
	width: 80%;
	margin-top: 5vh !important;
}
@media screen and (max-width: 992px) {
	.AppDetailedForcast .el-dialog {
		width: 95%;
	}
} */
</style>
